import { render, staticRenderFns } from "./RaceCardsWorkspace.vue?vue&type=template&id=2cd4da3c&scoped=true"
import script from "./RaceCardsWorkspace.vue?vue&type=script&lang=js"
export * from "./RaceCardsWorkspace.vue?vue&type=script&lang=js"
import style0 from "./RaceCardsWorkspace.vue?vue&type=style&index=0&id=2cd4da3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../2026-08-26/github-cli-gh-codex/work/jiangkv3/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd4da3c",
  null
  
)

export default component.exports